import _ from 'lodash'

function generateRandomHexString(length) {
  return _.times(length, () => _.random(15).toString(16)).join('');
}

export default class Tracer {
  constructor(applicationName) {
    this.applicationName = applicationName
  }

  configureAxios(axios) {
    axios.interceptors.request.use(config => {
      config.headers.common = {
        ...config.headers.common,
        'X-B3-TraceId': generateRandomHexString(32),
        'X-B3-SpanId': generateRandomHexString(16)
      }
      return config
    })

    return axios
  }
}



// WEBPACK FOOTER //
// ./src/services/Tracer.js